// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tamanos-Terrenos {
  background-color: #f5f5f5;
}
.Tamanos-Terrenos .tamanos-container {
  margin: 20px auto 40px;
  width: 99.8%;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item {
  min-height: auto;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.uno {
  margin-bottom: 34px;
  min-height: 580px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
}
@media (max-width: 900px) {
  .Tamanos-Terrenos .tamanos-container .tamanos-item.uno {
    min-height: 170px;
  }
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 80%;
  background-color: #f5f5f5;
  border: solid 10px #d9d9d9;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos .content-up-bottom {
  width: 90%;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos .content-up-bottom.upp {
  margin-top: 2em;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos .content-up-bottom.upp .Eng-elementos {
  margin-left: 2em;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos .content-up-bottom.bottomm {
  margin-bottom: 36px;
}
@media (max-width: 900px) {
  .Tamanos-Terrenos .tamanos-container .tamanos-item.dos .content-up-bottom.bottomm {
    margin-bottom: 20px;
  }
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos table {
  width: 93%;
}
@media (max-width: 900px) {
  .Tamanos-Terrenos .tamanos-container .tamanos-item.dos table {
    margin-bottom: 0.5em;
  }
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos table thead tr th {
  font-size: 16px;
  background-color: #b3282d;
  color: #ffffff;
  padding: 10px 0 10px 14px;
  text-align: left;
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos table tbody tr td {
  border: #e0e0e0 solid 1px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  padding: 8px 0px 8px 14px;
  color: #4f4f4f;
}
@media (max-width: 900px) {
  .Tamanos-Terrenos .tamanos-container .tamanos-item.dos table tbody tr td {
    font-size: 12px;
    line-height: 14px;
  }
}
.Tamanos-Terrenos .tamanos-container .tamanos-item.dos table tbody tr td.uno {
  background-color: #e7cbcc;
}
.Tamanos-Terrenos .tamanos-item {
  max-width: 100%;
  box-sizing: border-box;
}
.Tamanos-Terrenos .tamanos-item.tres {
  width: 100%;
  max-width: 100% !important;
  flex-basis: 100% !important;
  margin: 1.25em auto 0;
  padding: 0 16px;
  box-sizing: border-box;
}
@media (min-width: 901px) {
  .Tamanos-Terrenos .tamanos-item.tres {
    padding: 0 24px;
  }
}
@media (min-width: 1280px) {
  .Tamanos-Terrenos .tamanos-item.tres {
    max-width: 1100px !important;
    padding: 0;
  }
}
.Tamanos-Terrenos .tamanos-item.tres .disponibilidad-carrusel {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 4px;
}
.Tamanos-Terrenos .tamanos-item.tres .disponibilidad-slider {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-list {
  width: 100%;
  overflow: hidden !important;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-slide {
  height: auto;
  float: left;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-slide > div {
  width: 100%;
  height: clamp(200px, 52vw, 420px);
  overflow: hidden;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-slider .slick-dots {
  position: relative;
  bottom: auto;
  margin: 10px 0 0;
  padding: 0;
  line-height: 0;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-slider .slick-dots li {
  margin: 0 5px;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-dots li.slick-active button:before {
  color: #b3282d;
}
.Tamanos-Terrenos .tamanos-item.tres .slick-arrow,
.Tamanos-Terrenos .tamanos-item.tres .slick-prev {
  display: none !important;
}
.Tamanos-Terrenos .tamanos-item.tres .backgrounds-containers {
  width: 100%;
  height: 100%;
  overflow: hidden;
  line-height: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.Tamanos-Terrenos .tamanos-item.tres .backgrounds-containers img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
}
@media (max-width: 900px) {
  .Tamanos-Terrenos .gridTabla {
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
}
.Tamanos-Terrenos .tablas-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 4px;
}
@media (min-width: 1280px) {
  .Tamanos-Terrenos .tablas-wrapper {
    overflow-x: visible;
  }
}
.Tamanos-Terrenos .tablas {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  min-width: min(100%, 320px);
  margin: 0 auto;
  padding: 0 8px;
  box-sizing: border-box;
}
@media (min-width: 1280px) {
  .Tamanos-Terrenos .tablas {
    flex-wrap: nowrap;
    padding: 0 4px;
  }
}
.Tamanos-Terrenos .mi-tabla,
.Tamanos-Terrenos .mi-tabla_2 {
  width: 100%;
  max-width: 540px;
  height: auto;
  border-collapse: collapse;
  table-layout: fixed;
}
@media (min-width: 1280px) {
  .Tamanos-Terrenos .mi-tabla,
  .Tamanos-Terrenos .mi-tabla_2 {
    flex: 1 1;
    min-width: 0;
    max-width: calc((100% - 24px) / 3);
  }
}
.Tamanos-Terrenos .mi-tabla td,
.Tamanos-Terrenos .mi-tabla_2 td {
  padding: 8px 6px 8px 10px;
  vertical-align: middle;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 1.25;
}
@media (max-width: 600px) {
  .Tamanos-Terrenos .mi-tabla td,
  .Tamanos-Terrenos .mi-tabla_2 td {
    padding: 6px 4px 6px 8px;
    font-size: 12px;
    line-height: 1.3;
  }
}
.Tamanos-Terrenos .celdas_negras {
  background-color: #000000;
  color: white;
  font-size: clamp(16px, 2.2vw, 26px);
  font-weight: 900;
  line-height: 1.2;
  text-align: center;
  padding: 10px 6px !important;
}
.Tamanos-Terrenos .celdas_B_fases {
  background: #f5f5f5;
  color: #cb100b;
  font-size: clamp(13px, 1.8vw, 22px);
  font-weight: 500;
  line-height: 1.25;
  border: 1px solid #000000;
  margin-bottom: 0 !important;
  padding: 8px 6px !important;
  text-align: center;
}
.Tamanos-Terrenos .celdas_blancas {
  background-color: #f5f5f5;
  color: black;
  font-size: 16px;
  border-bottom: #cb100b;
  border-left: #cb100b;
}
.Tamanos-Terrenos .celdas_grises {
  background-color: #666666;
  color: white;
  font-size: clamp(12px, 1.6vw, 16px);
}
.Tamanos-Terrenos .celdas_rojas {
  background-color: #cb100b;
  color: white;
  font-size: clamp(11px, 1.5vw, 15px);
  font-weight: 700;
}
.Tamanos-Terrenos .texto_pequeno {
  font-size: clamp(8px, 1.4vw, 10px);
  color: #666666;
  display: block;
  line-height: 1.35;
  margin-top: 2px;
}
.Tamanos-Terrenos .promo-anticipo {
  width: 100%;
  max-width: 920px;
  margin: 14px auto 0;
  padding: 0 16px;
  text-align: center;
  box-sizing: border-box;
}
.Tamanos-Terrenos .promo-anticipo p {
  margin: 0 0 6px;
  font-weight: 600;
  font-size: clamp(13px, 2.4vw, 16px);
  line-height: 1.45;
  color: #333;
}
.Tamanos-Terrenos .promo-anticipo .promo-anticipo__highlight {
  color: #cb100b;
}
.Tamanos-Terrenos .tablas-contacto-btn {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
  max-width: calc(100% - 32px);
  margin: 12px auto;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Sections/Tamanosterrenos/Tamanosterrenos.scss","webpack://./src/utils/scss/Constants.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAGE;EACE,sBAAA;EACA,YAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAGM;EACE,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;AADR;AAGQ;EAPF;IAQI,iBAAA;EAAR;AACF;AAGM;EACE,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AADR;AAGQ;EACE,UAAA;AADV;AAGU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AADZ;AAGY;EACE,gBAAA;AADd;AAKU;EACE,mBAAA;AAHZ;AAKY;EAHF;IAII,mBAAA;EAFZ;AACF;AAMQ;EACE,UAAA;AAJV;AAMU;EAHF;IAII,oBAAA;EAHV;AACF;AAOc;EACE,eAAA;EACA,yBCXA;EDYA,cAAA;EACA,yBAAA;EACA,gBAAA;AALhB;AAYc;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAVhB;AAYgB;EATF;IAUI,eAAA;IACA,iBAAA;EAThB;AACF;AAWgB;EACE,yBCnCF;AD0BhB;AAoBE;EACE,eAAA;EACA,sBAAA;AAlBJ;AAoBI;EACE,WAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AAlBN;AAoBM;EARF;IASI,eAAA;EAjBN;AACF;AAmBM;EAZF;IAaI,4BAAA;IACA,UAAA;EAhBN;AACF;AAkBM;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAhBR;AAmBM;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAjBR;AAqBM;EACE,WAAA;EACA,2BAAA;AAnBR;AAsBM;EACE,YAAA;EACA,WAAA;AApBR;AAsBQ;EACE,WAAA;EACA,iCAAA;EACA,gBAAA;AApBV;AAwBM;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAtBR;AAyBM;EACE,aAAA;AAvBR;AA0BM;EACE,cC/GQ;ADuFhB;AA2BM;;EAEE,wBAAA;AAzBR;AA4BM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;AA1BR;AA4BQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AA1BV;AAiCI;EADF;IAEI,2BAAA;IACA,0BAAA;EA9BJ;AACF;AAiCE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AA/BJ;AAiCI;EAPF;IAQI,mBAAA;EA9BJ;AACF;AAiCE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;AA/BJ;AAiCI;EAZF;IAaI,iBAAA;IACA,cAAA;EA9BJ;AACF;AAiCE;;EAEE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AA/BJ;AAiCI;EARF;;IASI,SAAA;IACA,YAAA;IACA,kCAAA;EA7BJ;AACF;AA+BI;;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AA5BN;AA8BM;EARF;;IASI,wBAAA;IACA,eAAA;IACA,gBAAA;EA1BN;AACF;AA8BE;EACE,yBAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;AA7BJ;AAgCE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;AA9BJ;AAiCE;EACE,yBAAA;EACA,YAAA;EACA,mCAAA;AA/BJ;AAkCE;EACE,yBAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;AAhCJ;AAmCE;EACE,kCAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAlCJ;AAoCI;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,WAAA;AAlCN;AAqCI;EACE,cAAA;AAnCN;AAuCE;EACE,cAAA;EACA,uBAAA;EAAA,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;AArCJ","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.Tamanos-Terrenos {\n  background-color: #f5f5f5;\n\n  .tamanos-container {\n    margin: 20px auto 40px;\n    width: 99.8%;\n\n    .tamanos-item {\n      min-height: auto;\n\n      &.uno {\n        margin-bottom: 34px;\n        min-height: 580px;\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: 100%;\n\n        @media (max-width: 900px) {\n          min-height: 170px;\n        }\n      }\n\n      &.dos {\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: 80%;\n        background-color: #f5f5f5;\n        border: solid 10px #d9d9d9;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n        padding: 0;\n\n        .content-up-bottom {\n          width: 90%;\n\n          &.upp {\n            margin-top: 2em;\n            display: flex;\n            flex-direction: row;\n            align-items: flex-start;\n            justify-content: flex-start;\n\n            .Eng-elementos {\n              margin-left: 2em;\n            }\n          }\n\n          &.bottomm {\n            margin-bottom: 36px;\n\n            @media (max-width: 900px) {\n              margin-bottom: 20px;\n            }\n          }\n        }\n\n        table {\n          width: 93%;\n\n          @media (max-width: 900px) {\n            margin-bottom: 0.5em;\n          }\n\n          thead {\n            tr {\n              th {\n                font-size: 16px;\n                background-color: $color_tabla_1; //#b3282d;\n                color: #ffffff;\n                padding: 10px 0 10px 14px;\n                text-align: left;\n              }\n            }\n          }\n\n          tbody {\n            tr {\n              td {\n                border: #e0e0e0 solid 1px;\n                font-family: \"Montserrat\", sans-serif;\n                font-size: 16px;\n                font-weight: 500;\n                line-height: 18px;\n                padding: 8px 0px 8px 14px;\n                color: #4f4f4f;\n\n                @media (max-width: 900px) {\n                  font-size: 12px;\n                  line-height: 14px;\n                }\n\n                &.uno {\n                  background-color: $color_tabla_2; //#e7cbcc;\n                }\n              }\n            }\n          }\n        }\n      }\n\n    }\n  }\n\n  .tamanos-item {\n    max-width: 100%;\n    box-sizing: border-box;\n\n    &.tres {\n      width: 100%;\n      max-width: 100% !important;\n      flex-basis: 100% !important;\n      margin: 1.25em auto 0;\n      padding: 0 16px;\n      box-sizing: border-box;\n\n      @media (min-width: 901px) {\n        padding: 0 24px;\n      }\n\n      @media (min-width: 1280px) {\n        max-width: 1100px !important;\n        padding: 0;\n      }\n\n      .disponibilidad-carrusel {\n        width: 100%;\n        margin: 0 auto;\n        overflow: hidden;\n        border-radius: 4px;\n      }\n\n      .disponibilidad-slider {\n        width: 100%;\n        overflow: hidden;\n        position: relative;\n      }\n\n      // No max-width en .slick-track: apila los slides en vertical.\n      .slick-list {\n        width: 100%;\n        overflow: hidden !important;\n      }\n\n      .slick-slide {\n        height: auto;\n        float: left;\n\n        > div {\n          width: 100%;\n          height: clamp(200px, 52vw, 420px);\n          overflow: hidden;\n        }\n      }\n\n      .slick-slider .slick-dots {\n        position: relative;\n        bottom: auto;\n        margin: 10px 0 0;\n        padding: 0;\n        line-height: 0;\n      }\n\n      .slick-slider .slick-dots li {\n        margin: 0 5px;\n      }\n\n      .slick-dots li.slick-active button:before {\n        color: $color_tabla_1;\n      }\n\n      .slick-arrow,\n      .slick-prev {\n        display: none !important;\n      }\n\n      .backgrounds-containers {\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        line-height: 0;\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: cover;\n\n        img {\n          width: 100%;\n          height: 100%;\n          display: block;\n          object-fit: cover;\n          object-position: center;\n        }\n      }\n    }\n  }\n\n  .gridTabla {\n    @media (max-width: 900px) {\n      flex-basis: 100% !important;\n      max-width: 100% !important;\n    }\n  }\n\n  .tablas-wrapper {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 4px;\n\n    @media (min-width: 1280px) {\n      overflow-x: visible;\n    }\n  }\n\n  .tablas {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    justify-content: center;\n    align-items: stretch;\n    width: 100%;\n    min-width: min(100%, 320px);\n    margin: 0 auto;\n    padding: 0 8px;\n    box-sizing: border-box;\n\n    @media (min-width: 1280px) {\n      flex-wrap: nowrap;\n      padding: 0 4px;\n    }\n  }\n\n  .mi-tabla,\n  .mi-tabla_2 {\n    width: 100%;\n    max-width: 540px;\n    height: auto;\n    border-collapse: collapse;\n    table-layout: fixed;\n\n    @media (min-width: 1280px) {\n      flex: 1 1 0;\n      min-width: 0;\n      max-width: calc((100% - 24px) / 3);\n    }\n\n    td {\n      padding: 8px 6px 8px 10px;\n      vertical-align: middle;\n      word-wrap: break-word;\n      overflow-wrap: anywhere;\n      font-size: 15px;\n      line-height: 1.25;\n\n      @media (max-width: 600px) {\n        padding: 6px 4px 6px 8px;\n        font-size: 12px;\n        line-height: 1.3;\n      }\n    }\n  }\n\n  .celdas_negras {\n    background-color: #000000;\n    color: white;\n    font-size: clamp(16px, 2.2vw, 26px);\n    font-weight: 900;\n    line-height: 1.2;\n    text-align: center;\n    padding: 10px 6px !important;\n  }\n\n  .celdas_B_fases {\n    background: #f5f5f5;\n    color: #cb100b;\n    font-size: clamp(13px, 1.8vw, 22px);\n    font-weight: 500;\n    line-height: 1.25;\n    border: 1px solid #000000;\n    margin-bottom: 0 !important;\n    padding: 8px 6px !important;\n    text-align: center;\n  }\n\n  .celdas_blancas {\n    background-color: #f5f5f5;\n    color: black;\n    font-size: 16px;\n    border-bottom: #cb100b;\n    border-left: #cb100b;\n  }\n\n  .celdas_grises {\n    background-color: #666666;\n    color: white;\n    font-size: clamp(12px, 1.6vw, 16px);\n  }\n\n  .celdas_rojas {\n    background-color: #cb100b;\n    color: white;\n    font-size: clamp(11px, 1.5vw, 15px);\n    font-weight: 700;\n  }\n\n  .texto_pequeno {\n    font-size: clamp(8px, 1.4vw, 10px);\n    color: #666666;\n    display: block;\n    line-height: 1.35;\n    margin-top: 2px;\n  }\n\n  .promo-anticipo {\n    width: 100%;\n    max-width: 920px;\n    margin: 14px auto 0;\n    padding: 0 16px;\n    text-align: center;\n    box-sizing: border-box;\n\n    p {\n      margin: 0 0 6px;\n      font-weight: 600;\n      font-size: clamp(13px, 2.4vw, 16px);\n      line-height: 1.45;\n      color: #333;\n    }\n\n    .promo-anticipo__highlight {\n      color: #cb100b;\n    }\n  }\n\n  .tablas-contacto-btn {\n    display: block;\n    width: fit-content;\n    max-width: calc(100% - 32px);\n    margin: 12px auto;\n    text-align: center;\n  }\n}","// Header \n$Moon: \"../../../assets/img/CiudadLaEncantada_Moon.png\";\n$Sun: \"../../../assets/img/CiudadLaEncantada_Sun.png\";\n$Header_Section_Background: \"../../assets/img/CIUDAD_ENCANTADA_HEADER_SECTION_BACKGROUND.png\";\n\n// Desarrollo\n$Desarrollo_Backgroud: \"../../assets/img/CIUDAD_ENCANTADA_CLEDESARROLLO_BACKGROUND.png\";\n\n// Galeria \n$Galeria_Backgroud : \"../../assets/img/CIUDAD_ENCANTALA_GALERIA_BACKGROUND.png\";\n\n// Infraestructura\n$Infraestructura_Background: \"../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png\";\n\n// Amenidades\n$ParqueCentral: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PARQUE_CENTRAL.png\";\n$ParqueCentralHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PARQUE_CENTRAL_HOVER.png\";\n$PlazaComercial: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PLAZAS_COMERCIALES.jpeg\";\n$PlazaComercialHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PLAZAS_COMERCIALES_HOVER.png\";\n$Colegio: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_COLEGIO.png\";\n$ColegioHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_COLEGIO_HOVER.png\";\n$AreaVerde: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_AREA_VERDE.jpeg\";\n$AreaVerdeHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_AREA_VERDE_HOVER.png\";\n$Restaurante: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_RESTAURANTES.png\";\n$RestauranteHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_RESTAURANTESHOVER.png\";\n$Servicios: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_SERVICIOS.jpeg\";\n$ServiciosHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_SERVICIOS_HOVER.png\";\n\n// Presentacion\n$Presentacion_Background: \"../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png\";\n\n// Tamaños terrenos\n$Map : \"../../assets/img/Ciudadlaencantada_Map.png\";\n$Tamaños_Render1 : \"../../assets/img/CIUDAD_ENCANTADA_TAMANOS_RENDER1.png\";\n$Tamaños_Render2: \"../../assets/img/CIUDAD_ENCANTADA_TAMANOS_RENDER2.png\";\n$Tamaños_Render3: \"../../assets/img/CIUDAD_ENCANTADA_TAMANOS_RENDER3.png\";\n\n// Ubicacion \n$Ubicacion_Background: \"../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png\";\n$Ubicacion_Mapa: \"../../assets/img/CIUDAD_ENCANTADA_UBICACION_BACKGROUND_MAPA.png\";\n\n// Formulacio contacto\n$Form_Contacto: \"../../assets/img/CIUDAD_ENCANTADA_CONTACTO_BACKGROUND_FORMULARIO.png\";\n\n// HEX = b3282d\n// Color de la pagina \n$color_principa: #b3282d;\n$color_botones: #b3282d;\n$color_botones2: #fff;\n$color_border_switch_header: #b3282d;\n$color_switch-knob_header: #b3282d;\n$color_texto_hover: #b3282d;\n$color_background_phone_whats: #b3282d;\n$color_footer: #b3282d;\n\n// Formulario\n$color_formulario_1: #bc4f53;\n$color_formulario_2: #b3282d;\n\n// Tabla Disponibilidad\n$color_tabla_1: #b3282d;\n$color_tabla_2: #e7cbcc;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
